import { Link } from 'react-router-dom';
import { FormattedDate, FormattedMessage } from 'react-intl';

function Footer({ setOpenPrivacyModal }) {
  return (
    <div className="snf-lx-components-common-footer-footer" style={{ display: 'contents' }}>
      <>
        <footer className="snf-bg-color-prussian-blue pt-5 pb-4 text-white footerHeight">
          <div className="row m-0">
            <div className="col-12 col-lg-5 text-center text-lg-left p-0">
              <img
                className="mw-100"
                src="/images/logo-sistemi-expanded.svg"
                alt="Logo Sistemi Informativi"
                width="253"
                height="auto"
              />
            </div>
          </div>

          <div className="row m-0 mt-2 snf-font-12 text-center text-lg-left justify-content-between">
            {/* primo blocco */}
            <div className="col-12 col-lg-4 mt-3 p-0">
              <div className="mb-2">
                <FormattedMessage
                  defaultMessage="Copyright ©"
                  description="Sistemi Informativi label Copyright - Footer label"
                />
                &nbsp;
                <FormattedDate value={new Date()} year="numeric" />{' '}
                <FormattedMessage
                  defaultMessage="Sistemi Informativi S.r.l."
                  description="Sistemi Informativi label and VAT - Footer label"
                />
              </div>
              <div className="mb-2">
                <FormattedMessage
                  defaultMessage="An IBM company all Rights Reserved."
                  description="Sistemi Informativi label and VAT - Footer label"
                />
              </div>
              <div className="mb-2">
                <a
                  href="http://maps.google.com/?q=Via Luigi Stipa, 150 - 00148 ROMA"
                  rel="noreferrer"
                  target="_blank"
                  className="snf-color-white"
                >
                  <FormattedMessage
                    defaultMessage="Via Luigi Stipa, 150 - 00148 ROMA"
                    description="Sistemi Informativi label and VAT - Footer label"
                  />
                </a>
              </div>
              <div className="mb-2">
                {/* <div className="d-block d-md-inline mb-2 mb-md-0">
                <FormattedMessage
                  defaultMessage="Tel. "
                  description="Sistemi Informativi Tel and Fax - Footer label"
                />
                &nbsp;
                <a href="tel:+39 06 87793328" className="snf-color-white">
                  <FormattedMessage
                    defaultMessage="+39 06 87793328"
                    description="Sistemi Informativi Tel anchor - Footer label"
                  />
                </a>
              </div> */}
                {/* <div className="d-md-inline d-none">&nbsp;-&nbsp;</div> */}
                <div className="d-block d-md-inline mb-2 mb-md-0">
                  <FormattedMessage
                    defaultMessage="Fax"
                    description="Sistemi Informativi Fax label - Footer label"
                  />
                  &nbsp;
                  <a href="tel:+39 06 52206164" className="snf-color-white">
                    <FormattedMessage
                      defaultMessage="+39 06 52206164"
                      description="Sistemi Informativi Fax anchor - Footer label"
                    />
                  </a>
                </div>
                <div className="d-md-inline d-none">&nbsp;-&nbsp;</div>
                <a href="mailto:sistemi.informativi@pec.sistinf.it" className="snf-color-white">
                  <FormattedMessage
                    defaultMessage="sistemi.informativi@pec.sistinf.it"
                    description="Sistemi Informativi Fax anchor - Footer label"
                  />
                </a>
              </div>
              <div>
                <div className="d-block d-md-inline mb-2 mb-md-0">
                  <FormattedMessage
                    defaultMessage="C:F: e Reg. Imprese RM:06310880585"
                    description="Sistemi Informativi C:F: and P.IVA - Footer label"
                  />
                </div>
                <div className="d-md-inline d-none">&nbsp;-&nbsp;</div>
                <div className="d-block d-md-inline">
                  <FormattedMessage
                    defaultMessage="P.IVA 01528071002"
                    description="Sistemi Informativi C:F: and P.IVA - Footer label"
                  />
                </div>
              </div>
            </div>

            {/* <div className="d-flex width justify-content-center mt-3 mt-lg-0">
            <div className="row mb-2 mb-md-0 justify-content-center">
              <div className="col-auto p-0">
                <div className="snf-font-19 font-weight-bold mb-2 mb-md-3">
                  <Link to="/contatti" className="text-white">
                    <FormattedMessage
                      defaultMessage="Contatti"
                      description="Contatti - Footer link"
                    />
                  </Link>
                </div>
                <div className="snf-font-13">
                  <a
                    className="text-white"
                    rel="noreferrer"
                    target="_blank"
                    href="/assets/condizioni-di-utilizzo.pdf"
                  >
                    <FormattedMessage
                      defaultMessage="Condizioni di utilizzo"
                      description="Scopri Sistinf - Footer link"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="row mb-2 mb-md-0 justify-content-center">
              <div className="col-auto px-3">
                <div className="snf-font-19 font-weight-bold mb-2 mb-md-3">
                  <a
                    className="text-white"
                    rel="noreferrer"
                    target="_blank"
                    href="https://it.linkedin.com/company/sistemi-informativi"
                  >
                    <FormattedMessage
                      defaultMessage="Linkedin"
                      description="Linkedin - Footer link"
                    />
                  </a>
                </div>
                <div className="snf-font-13">
                  <a
                    className="text-white"
                    rel="noreferrer"
                    target="_blank"
                    href="/assets/Dichiarazione-di-tutela-della-privacy-Sistemi-Informativi.pdf"
                  >
                    <FormattedMessage
                      defaultMessage="Privacy"
                      description="Privacy - Footer link"
                    />
                  </a>
                </div>
                
              </div>
            </div>
            <div className="row m-0 justify-content-center">
              <div className="col-auto p-0">
                <div className="snf-font-19 font-weight-bold mb-2 mb-md-3">
                  <a
                    className="text-white"
                    rel="noreferrer"
                    target="_blank"
                    href="http://w3.sistinf.it"
                  >
                    <FormattedMessage
                      defaultMessage="Intranet (accesso solo tramite VPN)"
                      description="Intranet - Footer link"
                    />
                  </a>
                </div>
                <div className="snf-font-13">
                  <Link to="/segnalazioni" className="text-white">
                    <FormattedMessage
                      defaultMessage="Segnalazioni"
                      description="Segnalazioni - Whistleblowing"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
            {/* secondo blocco */}
            <div className="col-12 col-lg-8 mt-10 p-0" style={{ marginTop: 10 }}>
              {/* ROW 1: Contatti / Linkedin / Intranet */}
              <div className="row m-0 justify-content-center justify-content-lg-between ">
                <div className="col-auto p-0">
                  <div className="snf-font-19 font-weight-bold mb-2 mb-md-3">
                    <Link to="/contatti" className="text-white">
                      <FormattedMessage
                        defaultMessage="Contatti"
                        description="Contatti - Footer link"
                      />
                    </Link>
                  </div>
                </div>

                <div className="col-auto px-3">
                  <div className="snf-font-19 font-weight-bold mb-2 mb-md-3">
                    <a
                      className="text-white"
                      rel="noreferrer"
                      target="_blank"
                      href="https://it.linkedin.com/company/sistemi-informativi"
                    >
                      <FormattedMessage
                        defaultMessage="Linkedin"
                        description="Linkedin - Footer link"
                      />
                    </a>
                  </div>
                </div>

                <div className="col-auto p-0">
                  <div className="snf-font-19 font-weight-bold mb-2 mb-md-3">
                    <a
                      className="text-white"
                      rel="noreferrer"
                      target="_blank"
                      href="http://w3.sistinf.it"
                    >
                      <FormattedMessage
                        defaultMessage="Intranet (accesso solo tramite VPN)"
                        description="Intranet - Footer link"
                      />
                    </a>
                  </div>
                </div>
              </div>

              {/* ROW 2: Condizioni / Privacy / Cookie Policy / Segnalazioni */}
              <div className="row m-0 justify-content-center justify-content-lg-between">
                <div className="col-auto p-0">
                  <div className="snf-font-13">
                    <a
                      className="text-white"
                      rel="noreferrer"
                      target="_blank"
                      href="/assets/condizioni-di-utilizzo.pdf"
                    >
                      <FormattedMessage
                        defaultMessage="Condizioni di utilizzo"
                        description="Scopri Sistinf - Footer link"
                      />
                    </a>
                  </div>
                </div>

                <div className="col-auto px-3">
                  <div className="snf-font-13">
                    <a
                      className="text-white"
                      rel="noreferrer"
                      target="_blank"
                      href="/assets/Privacy OnLine Sistemi Informativi ITA-PRI 3.01.pdf"
                    >
                      <FormattedMessage
                        defaultMessage="Privacy"
                        description="Privacy - Footer link"
                      />
                    </a>
                  </div>
                </div>

                <div className="col-auto px-3">
                  <div className="snf-font-13">
                    <button
                      type="button"
                      className="text-white bg-transparent border-0 p-0"
                      style={{ textDecoration: 'none', cursor: 'pointer' }}
                      onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
                      onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
                      onClick={() => setOpenPrivacyModal(true)}
                    >
                      <FormattedMessage
                        defaultMessage="Cookie Policy"
                        description="Cookie Policy - Footer link"
                      />
                    </button>
                  </div>
                </div>

                <div className="col-auto p-0">
                  <div className="snf-font-13">
                    <Link to="/segnalazioni" className="text-white">
                      <FormattedMessage
                        defaultMessage="Segnalazioni"
                        description="Segnalazioni - Whistleblowing"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    </div>
  );
}

Footer.displayName = 'Footer';
export { Footer };
